var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0342 11.41H22.0002C21.8259 9.30703 20.7281 7.46235 19.1143 6.2832L16.8643 8.34418C18.0123 8.94822 18.8428 10.0773 19.0342 11.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13602 8.34422L4.88596 6.2832C3.27216 7.46239 2.17435 9.30707 2 11.4101H4.966C5.15749 10.0773 5.98789 8.94826 7.13602 8.34422Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41942 16.0801L5.93701 18.3535C6.87737 18.8163 7.93446 19.0768 9.05141 19.0768H11.4102V16.1284H9.05141C8.83657 16.1284 8.6255 16.1118 8.41942 16.0801Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05133 7.87229H11.4101V4.92383H9.05133C7.93442 4.92383 6.87733 5.18435 5.93701 5.64715L8.41906 7.92069C8.62522 7.88888 8.83637 7.87229 9.05133 7.87229Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5809 7.92072L18.0629 5.64718C17.1226 5.18435 16.0655 4.92383 14.9486 4.92383H12.5898V7.87229H14.9486C15.1636 7.87229 15.3747 7.88888 15.5809 7.92072Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.966 12.5898H2C2.17435 14.6928 3.27216 16.5375 4.88592 17.7166L7.13618 15.6558C5.98797 15.0518 5.15749 13.9227 4.966 12.5898Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9486 16.1284H12.5898V19.0768H14.9486C16.0655 19.0768 17.1227 18.8163 18.063 18.3535L15.5806 16.0801C15.3745 16.1118 15.1635 16.1284 14.9486 16.1284Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8638 15.6558L19.114 17.7167C20.7278 16.5375 21.8256 14.6928 21.9999 12.5898H19.034C18.8425 13.9227 18.012 15.0518 16.8638 15.6558Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9482 9.05176H9.05132C5.14418 9.20044 5.14713 14.8014 9.05132 14.9487H14.9482C18.8554 14.8 18.8524 9.19902 14.9482 9.05176ZM9.05132 13.1796H7.87194V10.8208H9.05132V13.1796ZM11.4101 13.1796H10.2307V10.8208H11.4101V13.1796ZM13.7689 13.1796H12.5895V10.8208H13.7689V13.1796ZM16.1276 13.1796H14.9482V10.8208H16.1276V13.1796Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoker);
export default __webpack_public_path__ + "static/media/poker.bb2ce3bc.svg";
export { ForwardRef as ReactComponent };